import { capitalize, compact } from 'lodash';
import { ALL_CAT_NAME } from 'site-modules/shared/constants/photoflipper/photoflipper';

export function getPicturesPageTitle({ displayVehicle, category, isMeta, totalPhotos = 0 }) {
  const isDefaultCategory = !category || category === ALL_CAT_NAME;
  const lastPart = isMeta && isDefaultCategory ? `- ${totalPhotos} Photos | Edmunds` : '';
  let mainPart = '';

  if (isDefaultCategory) {
    mainPart = `${displayVehicle} Pictures`;
  } else if (category === 'colors') {
    mainPart = `${displayVehicle} Color Options`;
  } else {
    mainPart = `${displayVehicle} ${capitalize(category)} Pictures`;
  }

  return compact([mainPart, lastPart])
    .join(' ')
    .replace(/\s+/g, ' ');
}
